//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './FileClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type CreateFileQueryParameters = {
  type: Types.FileType ;
  comment?: string | null | undefined ;
  dataBlockId?: number | null | undefined ;
  patientId?: number | null | undefined ;
  importId?: string | null | undefined ;
  templateId?: number | null | undefined ;
  start?: Date | null | undefined ;
  file?: Types.FileParameter | null | undefined ;
}

export type CreateFileMutationParameters = {
  file?: Types.FileParameter | null | undefined ;
}

export type SearchFilesFileQueryParameters = {
  patientId?: number | null | undefined ;
  dataBlockId?: number | null | undefined ;
  patientIds?: number[] | null | undefined ;
  fileNames?: string[] | null | undefined ;
  importIds?: string[] | null | undefined ;
  fileType?: Types.FileType | null | undefined ;
  excludeFileType?: Types.FileType[] | null | undefined ;
  isAllVersions?: boolean | null | undefined ;
  fileIds?: string[] | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  includeTransportStatuses?: boolean | null | undefined ;
}

export type UpdateFileFileQueryParameters = {
  fileId: string ;
  file?: Types.FileParameter | null | undefined ;
}

export type UpdateFileFileMutationParameters = {
  file?: Types.FileParameter | null | undefined ;
}

export type PublishDraftFileQueryParameters = {
  fileId: string ;
}

export type PatchFileFileQueryParameters = {
  id: string ;
}

export type DownloadFileFileQueryParameters = {
  fileId: string ;
  timestamp?: string | undefined ;
}

export type GetVersionHistoryFileQueryParameters = {
  groupId: string ;
}

export type GetFileInfoFileQueryParameters = {
  fileId: string ;
  includeTransportStatuses?: boolean | null | undefined ;
}

export type DeleteFileFileQueryParameters = {
  groupId: string ;
}

export type DeleteVersionFileQueryParameters = {
  versionId: string ;
}

export type SendFileByEmailFileQueryParameters = {
  fileId: string ;
  subtenantId?: number | undefined ;
}

export function createUrl(type: Types.FileType, comment?: string | null | undefined, dataBlockId?: number | null | undefined, patientId?: number | null | undefined, importId?: string | null | undefined, templateId?: number | null | undefined, start?: Date | null | undefined): string {
  let url_ = getBaseUrl() + "/api/files?";
  if (type === undefined || type === null)
    throw new Error("The parameter 'type' must be defined and cannot be null.");
  else
    url_ += "type=" + encodeURIComponent("" + type) + "&";
if (comment !== undefined && comment !== null)
    url_ += "comment=" + encodeURIComponent("" + comment) + "&";
if (dataBlockId !== undefined && dataBlockId !== null)
    url_ += "dataBlockId=" + encodeURIComponent("" + dataBlockId) + "&";
if (patientId !== undefined && patientId !== null)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
if (importId !== undefined && importId !== null)
    url_ += "importId=" + encodeURIComponent("" + importId) + "&";
if (templateId !== undefined && templateId !== null)
    url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
if (start !== undefined && start !== null)
    url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(type: Types.FileType, comment?: string | null | undefined, dataBlockId?: number | null | undefined, patientId?: number | null | undefined, importId?: string | null | undefined, templateId?: number | null | undefined, start?: Date | null | undefined): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'create',
      type as any,
      comment as any,
      dataBlockId as any,
      patientId as any,
      importId as any,
      templateId as any,
      start as any,
    ]);
}

/**
 * Creates new file
 * @param comment (optional) 
 * @param dataBlockId (optional) 
 * @param patientId (optional) 
 * @param importId (optional) 
 * @param templateId (optional) 
 * @param start (optional) 
 * @param file (optional) 
 */
export function useCreateMutation<TContext>(type: Types.FileType, comment?: string | null | undefined, dataBlockId?: number | null | undefined, patientId?: number | null | undefined, importId?: string | null | undefined, templateId?: number | null | undefined, start?: Date | null | undefined, options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, CreateFileMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileInfoDto, unknown, CreateFileMutationParameters, TContext> {
  const key = createMutationKey(type, comment, dataBlockId, patientId, importId, templateId, start);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createFileMutationParameters: CreateFileMutationParameters) => Client.create(type, comment, dataBlockId, patientId, importId, templateId, start, createFileMutationParameters.file),
    mutationKey: key,
  });
}
  
type Create__MutationParameters = CreateFileQueryParameters & {
  createFileMutationParameters: CreateFileMutationParameters;
}

/**
 * Creates new file
 * @param comment (optional) 
 * @param dataBlockId (optional) 
 * @param patientId (optional) 
 * @param importId (optional) 
 * @param templateId (optional) 
 * @param start (optional) 
 * @param file (optional) 
 */
export function useCreateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, Create__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateFileQueryParameters}): UseMutationResult<Types.FileInfoDto, unknown, Create__MutationParameters, TContext> {
  const key = createMutationKey(options?.parameters?.type!, options?.parameters?.comment!, options?.parameters?.dataBlockId!, options?.parameters?.patientId!, options?.parameters?.importId!, options?.parameters?.templateId!, options?.parameters?.start!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options, 
    mutationFn: (data: Create__MutationParameters) => Client.create(data.type, data.comment, data.dataBlockId, data.patientId, data.importId, data.templateId, data.start, data.file),
    mutationKey: key,
  });
}
  
export function searchFilesUrl(patientId?: number | null | undefined, dataBlockId?: number | null | undefined, patientIds?: number[] | null | undefined, fileNames?: string[] | null | undefined, importIds?: string[] | null | undefined, fileType?: Types.FileType | null | undefined, excludeFileType?: Types.FileType[] | null | undefined, isAllVersions?: boolean | null | undefined, fileIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeTransportStatuses?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/files?";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (dataBlockId !== undefined && dataBlockId !== null)
    url_ += "DataBlockId=" + encodeURIComponent("" + dataBlockId) + "&";
if (patientIds !== undefined && patientIds !== null)
    patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
if (fileNames !== undefined && fileNames !== null)
    fileNames && fileNames.forEach(item => { url_ += "FileNames=" + encodeURIComponent("" + item) + "&"; });
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (fileType !== undefined && fileType !== null)
    url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
if (excludeFileType !== undefined && excludeFileType !== null)
    excludeFileType && excludeFileType.forEach(item => { url_ += "ExcludeFileType=" + encodeURIComponent("" + item) + "&"; });
if (isAllVersions !== undefined && isAllVersions !== null)
    url_ += "IsAllVersions=" + encodeURIComponent("" + isAllVersions) + "&";
if (fileIds !== undefined && fileIds !== null)
    fileIds && fileIds.forEach(item => { url_ += "FileIds=" + encodeURIComponent("" + item) + "&"; });
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (includeTransportStatuses !== undefined && includeTransportStatuses !== null)
    url_ += "IncludeTransportStatuses=" + encodeURIComponent("" + includeTransportStatuses) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchFilesDefaultOptions: Omit<UseQueryOptions<Types.FileInfoDto[], unknown, Types.FileInfoDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileInfoDto[], unknown, Types.FileInfoDto[]>, 'queryFn'>> = {
};
export function getSearchFilesDefaultOptions() {
  return searchFilesDefaultOptions;
};
export function setSearchFilesDefaultOptions(options: typeof searchFilesDefaultOptions) {
  searchFilesDefaultOptions = options;
}

export function searchFilesQueryKey(dto: SearchFilesFileQueryParameters): QueryKey;
export function searchFilesQueryKey(patientId?: number | null | undefined, dataBlockId?: number | null | undefined, patientIds?: number[] | null | undefined, fileNames?: string[] | null | undefined, importIds?: string[] | null | undefined, fileType?: Types.FileType | null | undefined, excludeFileType?: Types.FileType[] | null | undefined, isAllVersions?: boolean | null | undefined, fileIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeTransportStatuses?: boolean | null | undefined): QueryKey;
export function searchFilesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, dataBlockId, patientIds, fileNames, importIds, fileType, excludeFileType, isAllVersions, fileIds, values, includeTransportStatuses,  } = params[0] as SearchFilesFileQueryParameters;

    return trimArrayEnd([
        'FileClient',
        'searchFiles',
        patientId as any,
        dataBlockId as any,
        patientIds as any,
        fileNames as any,
        importIds as any,
        fileType as any,
        excludeFileType as any,
        isAllVersions as any,
        fileIds as any,
        values as any,
        includeTransportStatuses as any,
      ]);
  } else {
    return trimArrayEnd([
        'FileClient',
        'searchFiles',
        ...params
      ]);
  }
}
export function __searchFiles(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.searchFiles(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as string[] | null | undefined,       context.queryKey[7] as Types.FileType | null | undefined,       context.queryKey[8] as Types.FileType[] | null | undefined,       context.queryKey[9] as boolean | null | undefined,       context.queryKey[10] as string[] | null | undefined,       context.queryKey[11] as { [key: string]: string[]; } | null | undefined,       context.queryKey[12] as boolean | null | undefined,axiosConfig    );
}

export function useSearchFilesQuery<TSelectData = Types.FileInfoDto[], TError = unknown>(dto: SearchFilesFileQueryParameters, options?: Omit<UseQueryOptions<Types.FileInfoDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns a list of files according to search criteria.
If IsAllVersions is false (or not set, by default),
returns only the Files with IsLatestVersion true.
 * @param patientId (optional) We have separate PatientId and PatientIds fields to make it easier to invalidate react-queries by patient id
 * @param dataBlockId (optional) 
 * @param patientIds (optional) 
 * @param fileNames (optional) 
 * @param importIds (optional) 
 * @param fileType (optional) 
 * @param excludeFileType (optional) 
 * @param isAllVersions (optional) 
 * @param fileIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeTransportStatuses (optional) 
 */
export function useSearchFilesQuery<TSelectData = Types.FileInfoDto[], TError = unknown>(patientId?: number | null | undefined, dataBlockId?: number | null | undefined, patientIds?: number[] | null | undefined, fileNames?: string[] | null | undefined, importIds?: string[] | null | undefined, fileType?: Types.FileType | null | undefined, excludeFileType?: Types.FileType[] | null | undefined, isAllVersions?: boolean | null | undefined, fileIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeTransportStatuses?: boolean | null | undefined, options?: Omit<UseQueryOptions<Types.FileInfoDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchFilesQuery<TSelectData = Types.FileInfoDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileInfoDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  let dataBlockId: any = undefined;
  let patientIds: any = undefined;
  let fileNames: any = undefined;
  let importIds: any = undefined;
  let fileType: any = undefined;
  let excludeFileType: any = undefined;
  let isAllVersions: any = undefined;
  let fileIds: any = undefined;
  let values: any = undefined;
  let includeTransportStatuses: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, dataBlockId, patientIds, fileNames, importIds, fileType, excludeFileType, isAllVersions, fileIds, values, includeTransportStatuses,  } = params[0] as SearchFilesFileQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, dataBlockId, patientIds, fileNames, importIds, fileType, excludeFileType, isAllVersions, fileIds, values, includeTransportStatuses, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileInfoDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __searchFiles(context, axiosConfig) : __searchFiles,
    queryKey: searchFilesQueryKey(patientId, dataBlockId, patientIds, fileNames, importIds, fileType, excludeFileType, isAllVersions, fileIds, values, includeTransportStatuses),
    ...searchFilesDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileInfoDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns a list of files according to search criteria.
If IsAllVersions is false (or not set, by default),
returns only the Files with IsLatestVersion true.
 * @param patientId (optional) We have separate PatientId and PatientIds fields to make it easier to invalidate react-queries by patient id
 * @param dataBlockId (optional) 
 * @param patientIds (optional) 
 * @param fileNames (optional) 
 * @param importIds (optional) 
 * @param fileType (optional) 
 * @param excludeFileType (optional) 
 * @param isAllVersions (optional) 
 * @param fileIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeTransportStatuses (optional) 
 */
export function setSearchFilesData(queryClient: QueryClient, updater: (data: Types.FileInfoDto[] | undefined) => Types.FileInfoDto[], patientId?: number | null | undefined, dataBlockId?: number | null | undefined, patientIds?: number[] | null | undefined, fileNames?: string[] | null | undefined, importIds?: string[] | null | undefined, fileType?: Types.FileType | null | undefined, excludeFileType?: Types.FileType[] | null | undefined, isAllVersions?: boolean | null | undefined, fileIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeTransportStatuses?: boolean | null | undefined) {
  queryClient.setQueryData(searchFilesQueryKey(patientId, dataBlockId, patientIds, fileNames, importIds, fileType, excludeFileType, isAllVersions, fileIds, values, includeTransportStatuses),
    updater
  );
}

/**
 * Returns a list of files according to search criteria.
If IsAllVersions is false (or not set, by default),
returns only the Files with IsLatestVersion true.
 * @param patientId (optional) We have separate PatientId and PatientIds fields to make it easier to invalidate react-queries by patient id
 * @param dataBlockId (optional) 
 * @param patientIds (optional) 
 * @param fileNames (optional) 
 * @param importIds (optional) 
 * @param fileType (optional) 
 * @param excludeFileType (optional) 
 * @param isAllVersions (optional) 
 * @param fileIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeTransportStatuses (optional) 
 */
export function setSearchFilesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileInfoDto[] | undefined) => Types.FileInfoDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateFileUrl(fileId: string): string {
  let url_ = getBaseUrl() + "/api/files/{fileId}";
if (fileId === undefined || fileId === null)
  throw new Error("The parameter 'fileId' must be defined.");
url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateFileMutationKey(fileId: string): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'updateFile',
      fileId as any,
    ]);
}

/**
 * Updates a file by either:
- adding a new version of a given file (if the file doesn't have a Draft)
- updating a Draft (if a Draft exists)
 * @param fileId Id of any file in a Group (or GroupId itself)
 * @param file (optional) 
 * @return A new version or a Draft
 */
export function useUpdateFileMutation<TContext>(fileId: string, options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, UpdateFileFileMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileInfoDto, unknown, UpdateFileFileMutationParameters, TContext> {
  const key = updateFileMutationKey(fileId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updateFileFileMutationParameters: UpdateFileFileMutationParameters) => Client.updateFile(fileId, updateFileFileMutationParameters.file),
    mutationKey: key,
  });
}
  
type UpdateFile__MutationParameters = UpdateFileFileQueryParameters & {
  updateFileFileMutationParameters: UpdateFileFileMutationParameters;
}

/**
 * Updates a file by either:
- adding a new version of a given file (if the file doesn't have a Draft)
- updating a Draft (if a Draft exists)
 * @param fileId Id of any file in a Group (or GroupId itself)
 * @param file (optional) 
 * @return A new version or a Draft
 */
export function useUpdateFileMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, UpdateFile__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateFileFileQueryParameters}): UseMutationResult<Types.FileInfoDto, unknown, UpdateFile__MutationParameters, TContext> {
  const key = updateFileMutationKey(options?.parameters?.fileId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options, 
    mutationFn: (data: UpdateFile__MutationParameters) => Client.updateFile(data.fileId, data.file),
    mutationKey: key,
  });
}
  
export function publishDraftUrl(fileId: string): string {
  let url_ = getBaseUrl() + "/api/files/{fileId}/draft/publish";
if (fileId === undefined || fileId === null)
  throw new Error("The parameter 'fileId' must be defined.");
url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function publishDraftMutationKey(fileId: string): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'publishDraft',
      fileId as any,
    ]);
}

/**
 * Publishes draft version, returns published version
 * @return Published version
 */
export function usePublishDraftMutation<TContext>(fileId: string, options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileInfoDto, unknown, void, TContext> {
  const key = publishDraftMutationKey(fileId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.publishDraft(fileId),
    mutationKey: key,
  });
}
  
type PublishDraft__MutationParameters = PublishDraftFileQueryParameters

/**
 * Publishes draft version, returns published version
 * @return Published version
 */
export function usePublishDraftMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, PublishDraft__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PublishDraftFileQueryParameters}): UseMutationResult<Types.FileInfoDto, unknown, PublishDraft__MutationParameters, TContext> {
  const key = publishDraftMutationKey(options?.parameters?.fileId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PublishDraft__MutationParameters) => Client.publishDraft(data.fileId ?? options?.parameters?.fileId!),
  mutationKey: key,
});
}
  
export function patchFileUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/files/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchFileMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'patchFile',
      id as any,
    ]);
}

export function usePatchFileMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, Types.PatchFileDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileInfoDto, unknown, Types.PatchFileDto, TContext> {
  const key = patchFileMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchFileDto) => Client.patchFile(id, dto),
    mutationKey: key,
  });
}
  
type PatchFile__MutationParameters = PatchFileFileQueryParameters & {
  dto: Types.PatchFileDto;
}

export function usePatchFileMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.FileInfoDto, unknown, PatchFile__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchFileFileQueryParameters}): UseMutationResult<Types.FileInfoDto, unknown, PatchFile__MutationParameters, TContext> {
  const key = patchFileMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PatchFile__MutationParameters) => Client.patchFile(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function downloadFileUrl(fileId: string, timestamp?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/files/{fileId}/data?";
if (fileId === undefined || fileId === null)
  throw new Error("The parameter 'fileId' must be defined.");
url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
if (timestamp === null)
    throw new Error("The parameter 'timestamp' cannot be null.");
else if (timestamp !== undefined)
    url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let downloadFileDefaultOptions: Omit<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryFn'>> = {
};
export function getDownloadFileDefaultOptions() {
  return downloadFileDefaultOptions;
};
export function setDownloadFileDefaultOptions(options: typeof downloadFileDefaultOptions) {
  downloadFileDefaultOptions = options;
}

export function downloadFileQueryKey(dto: DownloadFileFileQueryParameters): QueryKey;
export function downloadFileQueryKey(fileId: string, timestamp?: string | undefined): QueryKey;
export function downloadFileQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { fileId, timestamp,  } = params[0] as DownloadFileFileQueryParameters;

    return trimArrayEnd([
        'FileClient',
        'downloadFile',
        fileId as any,
        timestamp as any,
      ]);
  } else {
    return trimArrayEnd([
        'FileClient',
        'downloadFile',
        ...params
      ]);
  }
}
export function __downloadFile(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.downloadFile(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useDownloadFileQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: DownloadFileFileQueryParameters, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return literal file data of a given file version
 * @param fileId Id of a exact file version to be downloaded
 * @param timestamp (optional) Optional. You could pass any string to avoid caching on the frontend
 */
export function useDownloadFileQuery<TSelectData = Types.FileResponse, TError = unknown>(fileId: string, timestamp?: string | undefined, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDownloadFileQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let fileId: any = undefined;
  let timestamp: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ fileId, timestamp,  } = params[0] as DownloadFileFileQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [fileId, timestamp, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __downloadFile(context, axiosConfig) : __downloadFile,
    queryKey: downloadFileQueryKey(fileId, timestamp),
    ...downloadFileDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Return literal file data of a given file version
 * @param fileId Id of a exact file version to be downloaded
 * @param timestamp (optional) Optional. You could pass any string to avoid caching on the frontend
 */
export function setDownloadFileData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, fileId: string, timestamp?: string | undefined) {
  queryClient.setQueryData(downloadFileQueryKey(fileId, timestamp),
    updater
  );
}

/**
 * Return literal file data of a given file version
 * @param fileId Id of a exact file version to be downloaded
 * @param timestamp (optional) Optional. You could pass any string to avoid caching on the frontend
 */
export function setDownloadFileDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getVersionHistoryUrl(groupId: string): string {
  let url_ = getBaseUrl() + "/api/files/{groupId}/history";
if (groupId === undefined || groupId === null)
  throw new Error("The parameter 'groupId' must be defined.");
url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getVersionHistoryDefaultOptions: Omit<UseQueryOptions<Types.FileInfoDto[], unknown, Types.FileInfoDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileInfoDto[], unknown, Types.FileInfoDto[]>, 'queryFn'>> = {
};
export function getGetVersionHistoryDefaultOptions() {
  return getVersionHistoryDefaultOptions;
};
export function setGetVersionHistoryDefaultOptions(options: typeof getVersionHistoryDefaultOptions) {
  getVersionHistoryDefaultOptions = options;
}

export function getVersionHistoryQueryKey(groupId: string): QueryKey;
export function getVersionHistoryQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { groupId,  } = params[0] as GetVersionHistoryFileQueryParameters;

    return trimArrayEnd([
        'FileClient',
        'getVersionHistory',
        groupId as any,
      ]);
  } else {
    return trimArrayEnd([
        'FileClient',
        'getVersionHistory',
        ...params
      ]);
  }
}
export function __getVersionHistory(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getVersionHistory(
      context.queryKey[2] as string,axiosConfig    );
}

export function useGetVersionHistoryQuery<TSelectData = Types.FileInfoDto[], TError = unknown>(dto: GetVersionHistoryFileQueryParameters, options?: Omit<UseQueryOptions<Types.FileInfoDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get version history of a file
 * @param groupId Id of a file group. GroupId
 */
export function useGetVersionHistoryQuery<TSelectData = Types.FileInfoDto[], TError = unknown>(groupId: string, options?: Omit<UseQueryOptions<Types.FileInfoDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetVersionHistoryQuery<TSelectData = Types.FileInfoDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileInfoDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let groupId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ groupId,  } = params[0] as GetVersionHistoryFileQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [groupId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileInfoDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getVersionHistory(context, axiosConfig) : __getVersionHistory,
    queryKey: getVersionHistoryQueryKey(groupId),
    ...getVersionHistoryDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileInfoDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get version history of a file
 * @param groupId Id of a file group. GroupId
 */
export function setGetVersionHistoryData(queryClient: QueryClient, updater: (data: Types.FileInfoDto[] | undefined) => Types.FileInfoDto[], groupId: string) {
  queryClient.setQueryData(getVersionHistoryQueryKey(groupId),
    updater
  );
}

/**
 * Get version history of a file
 * @param groupId Id of a file group. GroupId
 */
export function setGetVersionHistoryDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileInfoDto[] | undefined) => Types.FileInfoDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getFileInfoUrl(fileId: string, includeTransportStatuses?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/files/{fileId}/info?";
if (fileId === undefined || fileId === null)
  throw new Error("The parameter 'fileId' must be defined.");
url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
if (includeTransportStatuses !== undefined && includeTransportStatuses !== null)
    url_ += "IncludeTransportStatuses=" + encodeURIComponent("" + includeTransportStatuses) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFileInfoDefaultOptions: Omit<UseQueryOptions<Types.FileInfoDto, unknown, Types.FileInfoDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileInfoDto, unknown, Types.FileInfoDto>, 'queryFn'>> = {
};
export function getGetFileInfoDefaultOptions() {
  return getFileInfoDefaultOptions;
};
export function setGetFileInfoDefaultOptions(options: typeof getFileInfoDefaultOptions) {
  getFileInfoDefaultOptions = options;
}

export function getFileInfoQueryKey(dto: GetFileInfoFileQueryParameters): QueryKey;
export function getFileInfoQueryKey(fileId: string, includeTransportStatuses?: boolean | null | undefined): QueryKey;
export function getFileInfoQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { fileId, includeTransportStatuses,  } = params[0] as GetFileInfoFileQueryParameters;

    return trimArrayEnd([
        'FileClient',
        'getFileInfo',
        fileId as any,
        includeTransportStatuses as any,
      ]);
  } else {
    return trimArrayEnd([
        'FileClient',
        'getFileInfo',
        ...params
      ]);
  }
}
export function __getFileInfo(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getFileInfo(
      context.queryKey[2] as string,       context.queryKey[3] as boolean | null | undefined,axiosConfig    );
}

export function useGetFileInfoQuery<TSelectData = Types.FileInfoDto, TError = unknown>(dto: GetFileInfoFileQueryParameters, options?: Omit<UseQueryOptions<Types.FileInfoDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetFileInfoQuery<TSelectData = Types.FileInfoDto, TError = unknown>(fileId: string, includeTransportStatuses?: boolean | null | undefined, options?: Omit<UseQueryOptions<Types.FileInfoDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFileInfoQuery<TSelectData = Types.FileInfoDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileInfoDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let fileId: any = undefined;
  let includeTransportStatuses: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ fileId, includeTransportStatuses,  } = params[0] as GetFileInfoFileQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [fileId, includeTransportStatuses, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileInfoDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getFileInfo(context, axiosConfig) : __getFileInfo,
    queryKey: getFileInfoQueryKey(fileId, includeTransportStatuses),
    ...getFileInfoDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileInfoDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetFileInfoData(queryClient: QueryClient, updater: (data: Types.FileInfoDto | undefined) => Types.FileInfoDto, fileId: string, includeTransportStatuses?: boolean | null | undefined) {
  queryClient.setQueryData(getFileInfoQueryKey(fileId, includeTransportStatuses),
    updater
  );
}

export function setGetFileInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileInfoDto | undefined) => Types.FileInfoDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function deleteFileUrl(groupId: string): string {
  let url_ = getBaseUrl() + "/api/files/{groupId}";
if (groupId === undefined || groupId === null)
  throw new Error("The parameter 'groupId' must be defined.");
url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteFileMutationKey(groupId: string): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'deleteFile',
      groupId as any,
    ]);
}

export function useDeleteFileMutation<TContext>(groupId: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteFileMutationKey(groupId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteFile(groupId),
    mutationKey: key,
  });
}
  
type DeleteFile__MutationParameters = DeleteFileFileQueryParameters

export function useDeleteFileMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteFile__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteFileFileQueryParameters}): UseMutationResult<void, unknown, DeleteFile__MutationParameters, TContext> {
  const key = deleteFileMutationKey(options?.parameters?.groupId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteFile__MutationParameters) => Client.deleteFile(data.groupId ?? options?.parameters?.groupId!),
  mutationKey: key,
});
}
  
export function deleteVersionUrl(versionId: string): string {
  let url_ = getBaseUrl() + "/api/files/versions/{versionId}";
if (versionId === undefined || versionId === null)
  throw new Error("The parameter 'versionId' must be defined.");
url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteVersionMutationKey(versionId: string): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'deleteVersion',
      versionId as any,
    ]);
}

export function useDeleteVersionMutation<TContext>(versionId: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteVersionMutationKey(versionId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteVersion(versionId),
    mutationKey: key,
  });
}
  
type DeleteVersion__MutationParameters = DeleteVersionFileQueryParameters

export function useDeleteVersionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteVersion__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteVersionFileQueryParameters}): UseMutationResult<void, unknown, DeleteVersion__MutationParameters, TContext> {
  const key = deleteVersionMutationKey(options?.parameters?.versionId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteVersion__MutationParameters) => Client.deleteVersion(data.versionId ?? options?.parameters?.versionId!),
  mutationKey: key,
});
}
  
export function sendFileByEmailUrl(fileId: string, subtenantId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/files/{fileId}/send-by-email?";
if (fileId === undefined || fileId === null)
  throw new Error("The parameter 'fileId' must be defined.");
url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
if (subtenantId === null)
    throw new Error("The parameter 'subtenantId' cannot be null.");
else if (subtenantId !== undefined)
    url_ += "subtenantId=" + encodeURIComponent("" + subtenantId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendFileByEmailMutationKey(fileId: string, subtenantId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'FileClient',
      'sendFileByEmail',
      fileId as any,
      subtenantId as any,
    ]);
}

/**
 * Send file by email.
 * @param subtenantId (optional) 
 */
export function useSendFileByEmailMutation<TContext>(fileId: string, subtenantId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sendFileByEmailMutationKey(fileId, subtenantId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendFileByEmail(fileId, subtenantId),
    mutationKey: key,
  });
}
  
type SendFileByEmail__MutationParameters = SendFileByEmailFileQueryParameters

/**
 * Send file by email.
 * @param subtenantId (optional) 
 */
export function useSendFileByEmailMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendFileByEmail__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendFileByEmailFileQueryParameters}): UseMutationResult<void, unknown, SendFileByEmail__MutationParameters, TContext> {
  const key = sendFileByEmailMutationKey(options?.parameters?.fileId!, options?.parameters?.subtenantId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendFileByEmail__MutationParameters) => Client.sendFileByEmail(data.fileId ?? options?.parameters?.fileId!, data.subtenantId ?? options?.parameters?.subtenantId!),
  mutationKey: key,
});
}